export const URL_IABS = 'https://drive.google.com/file/d/1DnJe5uecaiHCfujXidH0l8B8hwMHqlvx/view';
